import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Row, Col, H6, P} from '@modifi/ui'

import {DefaultComponentWrapper} from '../common'
import Picture from '../../ui/cms-picture'
import {PaddedContainer, StyledRow, TopImageWrapper, BottomImageWrapper} from './styles'

const uspsPropTypes = {
  usps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      topImage: PropTypes.string,
      bottomImage: PropTypes.string,
    }).isRequired
  ),
  itemsPerRow: PropTypes.oneOf([1, 2, 3, '1', '2', '3']),
  isTopImgLg: PropTypes.bool,
  isBottomImgLg: PropTypes.bool,
  backgroundColor: PropTypes.string,
}

const uspsDefaultProps = {
  usps: [],
  itemsPerRow: 3,
  isTopImgLg: false,
  isBottomImgLg: false,
  backgroundColor: undefined,
}

export type USPsProps = InferPropTypes<typeof uspsPropTypes, typeof uspsDefaultProps>

export const USPs: React.FC<USPsProps> = ({
  usps,
  itemsPerRow,
  isTopImgLg,
  isBottomImgLg,
  backgroundColor,
}) => (
  <DefaultComponentWrapper backgroundColor={backgroundColor}>
    <PaddedContainer>
      <Row>
        {usps?.map((usp, index) => {
          const {title, description, topImage, bottomImage} = usp
          const safeItemsPerRow =
            typeof itemsPerRow === 'string' ? parseInt(itemsPerRow, 10) : itemsPerRow || 3
          return (
            <Col
              lg={12 / safeItemsPerRow}
              // eslint-disable-next-line react/no-array-index-key
              key={`${title}-${index}`}
              my={32}
            >
              <StyledRow justifyContent="between">
                <Col>
                  {topImage && (
                    <TopImageWrapper isImgLg={isTopImgLg}>
                      <Picture alt={title} src={topImage} />
                    </TopImageWrapper>
                  )}
                  <H6>{title}</H6>
                  <P>{description}</P>
                </Col>
                {bottomImage && (
                  <Col mt={16}>
                    <BottomImageWrapper isImgLg={isBottomImgLg}>
                      <Picture alt={title} src={bottomImage} />
                    </BottomImageWrapper>
                  </Col>
                )}
              </StyledRow>
            </Col>
          )
        })}
      </Row>
    </PaddedContainer>
  </DefaultComponentWrapper>
)

USPs.propTypes = uspsPropTypes

USPs.defaultProps = uspsDefaultProps

export default USPs
